import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function parseDate(dateString: string): NgbDateStruct | null {
  if (!dateString) return null;

  const datePart = dateString.split('T')[0]; // Garde uniquement la partie YYYY-MM-DD
  const [year, month, day] = datePart.split('-').map(Number);

  return { year, month, day };
}

export function formatDateApi(dateObj: {
  year: number;
  month: number;
  day: number;
}): string {
  if (dateObj.year === undefined) return '';
  const year = dateObj.year;
  const month = String(dateObj.month).padStart(2, '0');
  const day = String(dateObj.day).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayInLetter(): string {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0'); // Jour
  const months = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];
  const month = months[today.getMonth()]; // Mois en texte
  const year = today.getFullYear(); // Année

  // Formater la date au format "25 Octobre 2023"
  return `${day} ${month} ${year}`;
}

export function getTodayDate(): string {
  let today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  return dd + '/' + mm + '/' + yyyy;
}

export function getListMonthTabItemBinaire() {
  return [
    { label: 'Janvier', id: '01' },
    { label: 'Février', id: '02' },
    { label: 'Mars', id: '03' },
    { label: 'Avril', id: '04' },
    { label: 'Mai', id: '05' },
    { label: 'Juin', id: '06' },
    { label: 'Juillet', id: '07' },
    { label: 'Août', id: '08' },
    { label: 'Septembre', id: '09' },
    { label: 'Octobre', id: '10' },
    { label: 'Novembre', id: '11' },
    { label: 'Décembre', id: '12' },
  ];
}

export function getListMonthStandard() {
  return [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Février' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Août' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Décembre' }
  ];
}

export function getCurrentYear(): number {
  const today = new Date();
  return today.getFullYear();
}

export function getCurrentMonth(): number {
  const today = new Date();
  return today.getMonth() + 1;
}

export function getYearsRange(range: number, year?: number): number[] {
  const initYear = year ? year : new Date().getFullYear();
  return Array.from({ length: range * 2 + 1 }, (_, i) => initYear - range + i);
}

export function formatDateStringToDatePicker(
  dateString: string
): { year: number; month: number; day: number } | null {
  if (!dateString) return null;
  // Utiliser parseDate pour éviter les problèmes de timezone
  const datePart = dateString.split('T')[0]; // Garde uniquement la partie YYYY-MM-DD
  const [year, month, day] = datePart.split('-').map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
  return {
    year,
    month,
    day,
  };
}

export function datePickerToDateString(dateObj: {
  year: number;
  month: number;
  day: number;
}): string {
  const year = dateObj.year;
  const month = String(dateObj.month).padStart(2, '0');
  const day = String(dateObj.day).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
